import { getList } from "./generics";
import { SUCCESS } from "../utils/constants/tags";
import ProductionMaterialCommitted from "../models/production-material-committed";

/**
 * Fetches, per batch, the raw-material amount committed by other production
 * orders that have not yet been discounted. Already-discounted orders are
 * excluded server-side because their consumption is already reflected in the
 * batch availability. Returns a Map keyed by batch id; batches with no pending
 * commitment are simply absent (treat as 0).
 */
export const getCommittedPendingByBatch = async (
  batchIds: number[],
  companyId: number | undefined,
  excludeOrderId: number | undefined,
): Promise<Map<number, number>> => {
  const committedByBatch = new Map<number, number>();

  if (batchIds.length === 0) {
    return committedByBatch;
  }

  const params = new Map<string, string | undefined>();
  params.set("batch_ids", batchIds.join(","));
  params.set("company_id", companyId !== undefined ? companyId.toString() : undefined);
  params.set(
    "exclude_order_id",
    excludeOrderId !== undefined ? excludeOrderId.toString() : undefined,
  );

  const result = await getList<ProductionMaterialCommitted>(
    "/production/materials/committed/",
    batchIds.length,
    0,
    params,
  );

  if (result.status === SUCCESS && result.data !== undefined) {
    for (const item of result.data.items) {
      committedByBatch.set(item.batchId, item.committedPending);
    }
  }

  return committedByBatch;
};
